import listReducer from './list/reducer';

export default {
  categoryList: listReducer,
};
